function u(e) {
  if (!e)
    return null;
  const [r, t, n = "1"] = e.split("-");
  return new Date(Number(r), Number(t), Number(n));
}
export {
  u as getCellValue
};
